import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'setUlStyle',
    standalone: false
})

export class SetUlStylePipe implements PipeTransform {

    transform(string: string): string {
        return string?.replace(/<ul>/g, '<ul style=\'list-style-type: disc; margin-left: 25px;\'>')
            .replace(/<ol>/g, '<ol style=\'list-style-type: disc; margin-left: 25px;\'>');
    }
}
